import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPointsSection } from './components/PainPointsSection';
import { ProtocolSection } from './components/ProtocolSection';
import { ContentsSection } from './components/ContentsSection';
import { AuthorStorySection } from './components/AuthorStorySection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-cream" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainPointsSection data-id="element-2" />
      <ProtocolSection data-id="element-3" />
      <ContentsSection data-id="element-4" />
      <AuthorStorySection data-id="element-5" />
      <FAQSection data-id="element-6" />
      <FinalCTASection data-id="element-7" />
      <Footer data-id="element-8" />
    </div>;
}